import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  path?: string;
  ogType?: string;
  jsonLd?: object | object[];
}

const SITE_NAME = "洞洞杂货铺 · 角色与设定科普站";

function toAbsoluteUrl(path: string): string {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  const base = (typeof __BASE_PATH__ !== "undefined" ? __BASE_PATH__ : "") || "";
  const basePath = base.split("/").filter(Boolean).join("/");
  const prefix = basePath ? `/${basePath}` : "";
  return `${origin}${prefix}${path.startsWith("/") ? path : `/${path}`}`;
}

export default function Seo({
  title,
  description,
  keywords,
  path = "/",
  ogType = "website",
  jsonLd,
}: SeoProps) {
  const canonical = toAbsoluteUrl(path);
  const fullTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {jsonLd ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(jsonLd),
          }}
        />
      ) : null}
    </>
  );
}